import React from "react";
import { formatDateFull } from "../../utils/helper";

const getStatus = (status) => {
  switch (status) {
    case "Acceptable":
      return "status-accept";
    case "Observe":
      return "status-observe";
    case "Alert":
      return "status-alert";
    case "Critical":
      return "status-critical";
    default:
      return "status-pending";
  }
};

export const MachineHealthNotification = ({ item }) => {
  const arr = item.description.split("|");
  const machine = arr[0];
  const location = arr[1];
  const health = arr[2];

  return (
    <div sx={{ fontSize: 12, mt: 1 }}>
      <div className="row" container spacing={1}>
        <div item className={"col-sm-12"}>
          <b> Machine Health Classification Update</b>
        </div>
        <div className={"col-sm-4"} item>
          Updated on
        </div>
        <div className={"col-sm-1"} item>
          :
        </div>
        <div className={"col-sm-7"} item>
          {formatDateFull(item.created_at)}
        </div>

        <div className={"col-sm-4"} item>
          Machine
        </div>
        <div className={"col-sm-1"} item>
          :
        </div>
        <div className={"col-sm-7"}>{machine}</div>

        <div className={"col-sm-4"}>Location</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{location}</div>

        <div className={"col-sm-4"}>Machine Health</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>
          <div
            style={{
              textAlign: "center",
              color: "#1e2936",
              fontWeight: "bold",
            }}
            className={getStatus(health)}
          >
            {health}
          </div>
        </div>
      </div>
    </div>
  );
};
